interface Props {
  warnings: string[];
}

export function Warnings({ warnings }: Props) {
  if (warnings.length === 0) return null;

  return (
    <div
      className="card"
      style={{
        marginBottom: '16px',
        background: 'rgba(255, 107, 53, 0.1)',
        borderColor: 'rgba(255, 107, 53, 0.3)',
      }}
    >
      <h3 style={{
        fontSize: '14px',
        fontWeight: 600,
        marginBottom: '10px',
        color: 'var(--risk-high)',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
      }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
        Warnings
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {warnings.map((warning, i) => (
          <div
            key={i}
            style={{
              fontSize: '13px',
              color: 'var(--text-secondary)',
              paddingLeft: '12px',
              borderLeft: '2px solid var(--risk-high)',
            }}
          >
            {warning}
          </div>
        ))}
      </div>
    </div>
  );
}
